// extracted by mini-css-extract-plugin
module.exports = {"secure":"secure--W3yv5"};